import React from 'react'
import clsx from 'clsx'

import { useBreakpoint } from '../../../../../providers/BreakpointProvider'
import useStyles from './styles'

const GroupWrapper = ({
  id,
  start,
  inside,
  end,
  children,
  noColor,
  className
}) => {
  const { isSmall } = useBreakpoint()

  const classes = useStyles({ smallMedia: isSmall })

  return (
    <div
      id={id}
      className={clsx(classes.root, className, {
        [classes.start]: start,
        [classes.inside]: inside,
        [classes.end]: end
      })}
      style={{ backgroundColor: noColor ? 'transparent' : 'white' }}
    >
      {children}
    </div>
  )
}

export default GroupWrapper
